module.exports = __webpack_public_path__ + "static/media/UHS_Logo_RGB_600px_200px.fee1037b.png";